import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Id } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  attachDocumentsToElement(
    request: Boundaries["attachDocumentsToElement"]["request"],
  ): void;
}

function useAttachDocumentsToElement(elementId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAttachDocumentsToElementRequestPending(elementId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAttachDocumentsToElementRequestSuccess(elementId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAttachDocumentsToElementRequestFailure(elementId),
    ),
    attachDocumentsToElement: core.attachDocumentsToElement,
  };
}

export { useAttachDocumentsToElement };
